import Spinner from 'components/Spinner';
import useCurrentLoggedInUser from 'hooks/apollo/queries/useCurrentLoggedInUser';
import React from 'react';
import { GeneralFunction } from 'types/common';
import { ILocation } from 'types/location';
import { formatAddress } from 'utils';

import IconComponent from '../IconComponent';

const LocaionSelectForm: React.FC<{
  locations?: ILocation[];
  loading?: boolean;
  onLocationSelect?: GeneralFunction;
}> = ({ locations, loading, onLocationSelect }) => {
  const { mainLocation } = useCurrentLoggedInUser(); // test nha
  return (
    <div>
      {locations?.map((location, index) => {
        const isCurrentMainLocation = location.id === mainLocation?.id;
        return (
          <React.Fragment key={location.id}>
            <div
              onClick={() => {
                if (!loading && onLocationSelect) onLocationSelect(location);
              }}
              className={`p-2 cursor-pointer justify-between flex h-8 border border-transparent hover:border-primary-color ${
                isCurrentMainLocation ? 'font-medium' : ''
              }`}
              style={{ transform: `translateY(${index === 0 ? 0 : -1}px)` }}>
              <div className='flex line-clamp-1'>
                {location.name} - {formatAddress(location.address)}
              </div>
              <div className='flex items-center'>
                {isCurrentMainLocation && !loading && <IconComponent name='check-circle-o' color='#038fde' />}
                {loading && (
                  <div className='ml-2'>
                    <Spinner color='#038fde' />
                  </div>
                )}
              </div>
            </div>
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default React.memo(LocaionSelectForm);
